import { PropsWithChildren } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from '@libs/store/auth';
import { accessCheck } from '@libs/api/accessCheck';

export function AuthGuard({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  // const { isAuthenticated } = useAuthStore();

  // if (!isAuthenticated()) {
  //   return <Navigate to="/login" />;
  // }

  accessCheck().then(()=>{
    return children;
  }).catch((error)=>{
    navigate('/404');
  });

  // if (!isAuthenticated()) {
  //   return <Navigate to="/error" />;
  // }

  return children;
}
